Object.defineProperty(exports,"__esModule",{value:true});exports.healthStateData=undefined;var _moment=require('moment');var _moment2=_interopRequireDefault(_moment);
var _positionHealthStatus=require('./positionHealthStatus');var _positionHealthStatus2=_interopRequireDefault(_positionHealthStatus);
var _securityDeviceHealthStatus=require('./securityDeviceHealthStatus');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var healthStateData=exports.healthStateData=function healthStateData(position){
var data=(0,_positionHealthStatus2.default)(position);
switch(data.type){
case _securityDeviceHealthStatus.HealthStatus.HEALTHY:{var _data$payload=
data.payload,message=_data$payload.message,action=_data$payload.action,since=_data$payload.since;
return{
healthStateType:data.type,
healthStateTitle:'Healthy',
healthStateMessage:message,
healthStateAction:action,
healthStateReason:null,
healthStateSince:since?
(0,_moment2.default)(since).format('MMM D YYYY hh:mm A'):
null};

}
case _securityDeviceHealthStatus.HealthStatus.UNHEALTHY:{var _data$payload2=
data.payload,_message=_data$payload2.message,_action=_data$payload2.action,_since=_data$payload2.since;
return{
healthStateType:data.type,
healthStateTitle:'Not Healthy',
healthStateMessage:_message,
healthStateAction:_action,
healthStateReason:null,
healthStateSince:_since?
(0,_moment2.default)(_since).format('MMM D YYYY hh:mm A'):
null};

}
case _securityDeviceHealthStatus.HealthStatus.HEALTH_WARNING:{var _data$payload3=
data.payload,_message2=_data$payload3.message,_action2=_data$payload3.action,_since2=_data$payload3.since;
return{
healthStateType:data.type,
healthStateTitle:'Warming',
healthStateMessage:_message2,
healthStateAction:_action2,
healthStateReason:null,
healthStateSince:_since2?
(0,_moment2.default)(_since2).format('MMM D YYYY hh:mm A'):
null};

}
default:
return{
healthStateType:_securityDeviceHealthStatus.HealthStatus.UNKNOWN,
healthStateTitle:'Unknown',
healthStateMessage:null,
healthStateAction:null,
healthStateReason:null,
healthStateSince:null};}


};